import React from 'react';
import TechnologyLogos from '../components/TechnologyLogos';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'PLC Programming',
      description: 'Custom programmable logic controller solutions designed to meet your specific automation requirements. We program and configure PLCs from leading manufacturers including Allen-Bradley (Rockwell), Siemens, Beckhoff, Bosch, and others.',
      details: [
        'Ladder logic, Function Block, and Structured Text programming',
        'System integration and communication setup',
        'Testing and commissioning',
        'Documentation and training'
      ]
    },
    {
      title: 'HMI Development',
      description: 'Intuitive human-machine interfaces that provide operators with clear, actionable information and easy system control. We design HMIs that improve productivity and reduce operator errors.',
      details: [
        'Custom screen design and layout',
        'Real-time data visualization',
        'Alarm and event management',
        'Multi-level user access control'
      ]
    },
    {
      title: 'Robotics Integration',
      description: 'Advanced robotic systems for precision manufacturing processes. We integrate industrial robots for material handling, assembly, welding, and other applications. Our expertise includes Fanuc, Kuka, ABB, Epson, Denso, Yaskawa, and Staubli robots.',
      details: [
        'Robot selection and specification',
        'End-of-arm tooling design',
        'Safety system integration',
        'Programming and path optimization',
        'Multi-robot coordination and cell design',
        'Robot brands: Fanuc, Kuka, ABB, Epson, Denso, Yaskawa, Staubli'
      ]
    },
    {
      title: 'Vision Systems & Computer Vision',
      description: 'Comprehensive machine vision solutions for quality control, inspection, and guidance applications. We utilize traditional vision systems (Cognex, Keyence) as well as custom PC-based computer vision using OpenCV. When needed, we integrate AI/ML/DL capabilities for advanced inspection and recognition tasks.',
      details: [
        'Traditional vision systems: Cognex, Keyence',
        'Custom PC-based solutions with OpenCV',
        'AI/ML/DL integration for advanced applications',
        'Camera and lighting selection',
        'Image processing algorithm development',
        'Defect detection and classification',
        'Real-time vision feedback for robotics',
        'Integration with production systems'
      ]
    },
    {
      title: 'Custom Machinery & Production Lines',
      description: 'Complete design and build of specialized automation equipment and production lines from scratch. Our multidisciplinary team of Mechanical Designers, Controls Electrical Engineers, and Software Engineers delivers turnkey solutions from concept to completion.',
      details: [
        'Conceptual design and engineering',
        'Mechanical design and fabrication',
        'Electrical and control system integration',
        'Complete production line design and build',
        'Installation and commissioning',
        'Controls commissioning: Rockwell, Siemens, Beckhoff, Bosch',
        'Full project lifecycle management'
      ]
    },
    {
      title: 'SCADA & Software Solutions',
      description: 'Comprehensive SCADA systems and custom software solutions for industrial automation. We develop complete SCADA projects using Ignition, Microsoft .NET stack, or modern web standards (React + Node.js). Our software engineers deliver enterprise-grade solutions tailored to your manufacturing needs.',
      details: [
        'SCADA system development with Ignition',
        'Microsoft .NET stack solutions (C#, ASP.NET, SQL Server)',
        'Web-based SCADA with React + Node.js',
        'Complete SCADA project implementation',
        'Real-time data acquisition and visualization',
        'MES/ERP integration',
        'Data collection, reporting, and analytics',
        'Custom software development for manufacturing'
      ]
    },
    {
      title: 'Motion Control',
      description: 'Precision motion control solutions for servo and stepper motor applications. Our engineers have extensive experience with Motion Coordinate Systems, Delta Robots, and packing machines with multiple motion control axes for high-speed solutions.',
      details: [
        'Motion Coordinate Systems (Rockwell)',
        'Delta Robot integration and programming',
        'High-speed packing machine solutions',
        'Multi-axis motion coordination',
        'Servo and stepper system design',
        'Motion profile development',
        'Performance optimization for high-speed applications'
      ]
    },
    {
      title: 'MES Systems',
      description: 'Manufacturing Execution Systems that provide real-time visibility and control over production processes. Our MES solutions integrate seamlessly with your existing systems.',
      details: [
        'Production planning and scheduling',
        'Real-time production monitoring',
        'Quality management integration',
        'Traceability and genealogy tracking'
      ]
    },
    {
      title: 'Traceability Systems',
      description: 'Complete traceability solutions that track products and components throughout the manufacturing process, ensuring compliance and quality control.',
      details: [
        'Serial number tracking',
        'Component genealogy',
        'Batch and lot tracking',
        'Compliance reporting and documentation'
      ]
    },
    {
      title: 'Web Solutions',
      description: 'Custom web applications and dashboards for manufacturing data visualization, remote monitoring, and enterprise integration.',
      details: [
        'Real-time dashboards and reporting',
        'Remote monitoring applications',
        'Data analytics and visualization',
        'Enterprise system integration'
      ]
    },
    {
      title: 'Project Management',
      description: 'Comprehensive project management services to ensure your automation project is delivered on time, on budget, and to specification.',
      details: [
        'Project planning and scheduling',
        'Resource allocation',
        'Risk management',
        'Progress reporting and communication'
      ]
    },
    {
      title: 'Production Support',
      description: 'Ongoing production support services to ensure your automation systems operate at peak performance. We provide 24/7, 365 days per year support, on-site or remotely.',
      details: [
        '24/7, 365 days per year support',
        'On-site and remote support capabilities',
        'Troubleshooting and issue resolution',
        'Preventive maintenance programs',
        'System optimization and performance tuning'
      ]
    },
    {
      title: 'Training Services',
      description: 'Comprehensive training programs for your team on various automation technologies. We offer training on PLC programming, HMI development, robotics, and other automation systems.',
      details: [
        'PLC programming training (Rockwell, Siemens, Beckhoff, Bosch)',
        'HMI development training',
        'Robotics programming and operation',
        'Vision systems training',
        'Custom training programs tailored to your needs',
        'On-site or remote training options'
      ]
    },
    {
      title: 'Machine Retrofits',
      description: 'On-site machine retrofit services to upgrade and modernize existing equipment. We can retrofit machines with new controls, improve performance, and extend equipment life.',
      details: [
        'On-site machine retrofits',
        'Control system upgrades',
        'Performance improvements',
        'Equipment modernization',
        'Minimal production downtime',
        'Cost-effective solutions'
      ]
    },
    {
      title: 'Virtual Commissioning',
      description: 'Virtual commissioning services using Siemens NX MCD (Mechatronics Concept Designer) to test and validate automation systems before physical implementation.',
      details: [
        'Siemens NX MCD virtual commissioning',
        'System validation before physical build',
        'Reduced commissioning time and costs',
        'Early error detection and correction',
        'Digital twin development',
        'Simulation and testing'
      ]
    },
    {
      title: 'Spare Parts',
      description: 'Supply of genuine spare parts and components for automation systems. We provide parts for PLCs, HMIs, drives, sensors, and other automation components.',
      details: [
        'Genuine automation parts and components',
        'PLC and HMI spare parts',
        'Drive and motor components',
        'Sensors and actuators',
        'Fast delivery and availability',
        'Technical support for part selection'
      ]
    }
  ];

  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p className="page-hero-subtitle">
            Comprehensive automation solutions for modern manufacturing
          </p>
        </div>
      </section>

      <section className="services-content">
        <div className="container">
          <div className="services-intro">
            <p>
              SCE Automated offers a full range of industrial automation services, 
              from initial concept through final implementation and support. Our 
              experienced team works closely with clients to understand their needs 
              and deliver solutions that drive real business value.
            </p>
            <p>
              <strong>Service & Support:</strong> We provide 24/7, 365 days per year service 
              and support. Our team can assist on-site or remotely, ensuring your automation 
              systems operate at peak performance whenever you need us.
            </p>
          </div>

          <div className="services-list">
            {services.map((service, index) => (
              <div key={index} className="service-detail-card">
                <h2>{service.title}</h2>
                <p className="service-description">{service.description}</p>
                <div className="service-details">
                  <h3>Key Capabilities:</h3>
                  <ul>
                    {service.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Technology Competencies Section */}
          <div className="technology-competencies-section">
            <h2>Technology Competencies</h2>
            <p className="competencies-intro">
              We work with leading technology platforms and tools to deliver best-in-class automation solutions.
            </p>
            <TechnologyLogos 
              logos={[
                // PLC
                { src: '/images/plc/rockwell-200x58.png', alt: 'Rockwell Automation', name: 'Rockwell' },
                { src: '/images/plc/siemens.png', alt: 'Siemens', name: 'Siemens' },
                { src: '/images/plc/Beckhoff_Logo.svg.png', alt: 'Beckhoff', name: 'Beckhoff' },
                { src: '/images/plc/rexroth_bosh.png', alt: 'Rexroth Bosch', name: 'Rexroth Bosch' },
                { src: '/images/plc/br.png', alt: 'B&R Automation', name: 'B&R' },
                // SCADA
                { src: '/images/scada/Ignition.png', alt: 'Ignition', name: 'Ignition' },
                { src: '/images/scada/kepware-color-logo.png', alt: 'Kepware', name: 'Kepware' },
                { src: '/images/scada/aveva-sm.svg', alt: 'Aveva', name: 'Aveva' },
                // HMI
                { src: '/images/hmi/factorytalk-logo-200x59-1.png', alt: 'FactoryTalk', name: 'FactoryTalk' },
                { src: '/images/hmi/optix-logo-200x59-1.png', alt: 'Optix', name: 'Optix' },
                // Vision
                { src: '/images/vision/2000px-Cognex_Corp_logo.svg.png', alt: 'Cognex', name: 'Cognex' },
                { src: '/images/vision/Keyence.svg.png', alt: 'Keyence', name: 'Keyence' },
                { src: '/images/vision/OpenCV_logo_no_text.png', alt: 'OpenCV', name: 'OpenCV' },
                { src: '/images/vision/python.png', alt: 'Python', name: 'Python' },
                { src: '/images/vision/C++_logo.png', alt: 'C++', name: 'C++' },
                // Robots
                { src: '/images/robots/fanuc-robots-logo.png', alt: 'Fanuc', name: 'Fanuc' },
                { src: '/images/robots/kuka.png', alt: 'Kuka', name: 'Kuka' },
                { src: '/images/robots/abb_robots.png', alt: 'ABB', name: 'ABB' },
                // Web & Software
                { src: '/images/web/React-icon.svg.png', alt: 'React', name: 'React' },
                { src: '/images/web/Node.js_logo.svg.png', alt: 'Node.js', name: 'Node.js' },
                { src: '/images/dotnet/logocharp.png', alt: 'C#', name: 'C#' },
                { src: '/images/dotnet/microsoft_logo.jpg', alt: 'Microsoft', name: 'Microsoft' },
                // Database
                { src: '/images/database/MicrosoftSQLServer.png', alt: 'SQL Server', name: 'SQL Server' },
                { src: '/images/database/PostgreSQL-logo.png', alt: 'PostgreSQL', name: 'PostgreSQL' },
                { src: '/images/database/Oracle-Logo.png', alt: 'Oracle', name: 'Oracle' },
                // Cloud
                { src: '/images/cloud/AWS-Logo_Nov-2017-Update.png', alt: 'AWS', name: 'AWS' },
                { src: '/images/cloud/2000px-Microsoft_Azure_Logo.svg.png', alt: 'Azure', name: 'Azure' },
                { src: '/images/docker-logo-blue.png', alt: 'Docker', name: 'Docker' }
              ]} 
            />
          </div>

          <div className="services-cta">
            <h2>Ready to Get Started?</h2>
            <p>Contact us to discuss your automation needs and how we can help</p>
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;

